'use client';

import { useQuery } from '@tanstack/react-query';
import { ReactNode, useMemo } from 'react';

import { getChild, getRandomChildren } from '@sola/proxy-sdk/children.js';

import { RandomChildContext } from './context.js';

export const RandomChildProvider = ({ children }: { children: ReactNode }) => {
  const { data, isLoading } = useQuery({
    queryKey: ['randomChild'],
    queryFn: async () => {
      const response = await getRandomChildren();
      const childId = response?.children?.[0]?.globalId || '';
      return await getChild(childId);
    },
  });

  const value = useMemo(() => ({ data, isLoading }), [data, isLoading]);

  return (
    <RandomChildContext.Provider value={value}>
      {children}
    </RandomChildContext.Provider>
  );
};
